<template>
  <div class="plan-premium-user">
    <div class="plan">
      <p>Founder Fee</p>
    </div>
    <div class="days-left">
      <p> <span class="daysToReactivate"> {{getDaysToReactivation()}} </span> left (1 year subscribed)</p>
      <p>Member since <span>{{ this.getDate(user.createdAt) }}</span></p>
    </div>
    <p>Automatic renewal</p>
    <button 
      class="orange-btn" 
      type='button' 
      @click='stopRenewal' 
      v-if='user.subscriptionActive'
    >
      Stop automatic renewals
    </button>
    <button 
      class="orange-btn" 
      type='button'
      @click='reactivateSubscription'
      v-if='subscriptionData.subscription.canceled_at'
    >
      Reactivate Subscription
    </button>
  </div>
</template>

<script>
import {axiosClient} from "@/axios-client";
import moment from 'moment';


export default {
  props: ['user'],

  data() {
    return {
      months: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul","Aug", "Sep", "Oct", "Nov", "Dec"],
      subscriptionData: {}
    }
  },

  created() {
    axiosClient.get('/v1/stripe/subscription')
      .then((res) => {
        this.subscriptionData = res.data;
        console.log(res.data);
      })
  },

  methods: {
    getDate(date) {
      let fullDate = new Date(date);
      let d = fullDate.getDate();
      let m = this.months[fullDate.getMonth()];
      let y = fullDate.getFullYear();
      return `${m} ${d}, ${y}`;
    },

    getDaysToReactivation() {
      return moment().to(moment(this.subscriptionData.subscription.current_period_end * 1000), true);
    },

    stopRenewal() {
      this.$store.commit('resultsAreLoading')

      axiosClient.patch('/v1/stripe/suspend-subscription')
        .then((res) => {
          this.$store.commit('resultsLoaded')
          window.location.href = '/cancel-renewal';
        })
    },

    reactivateSubscription() {
      this.$store.commit('resultsAreLoading')
  
      axiosClient.patch('/v1/stripe/reactivate-subscription')
        .then((res) => {
          this.$store.commit('resultsLoaded')
          window.location.href = '/thank-you';
        })
    }
  }
}
</script>

<style lang="scss">
  .plan-premium-user {
    display: flex;
    justify-content: space-between;

    .daysToReactivate {
      text-transform: capitalize;
    }

    p {
      margin: 0;
      color: #676868;
    }

    .orange-btn {
      border: none;
      padding: 0 20px;

      &:focus {
        outline: none;
      }
    }
  }
</style>